import { ThunkAction } from 'redux-thunk';
import { IContext, IState } from '../../store';
import { EUserType } from '../../constants/requestDemand';
import { trackBackToOffer } from '../../components/demand/utils/tracking';
import { closeDemandRequestModal } from './requestDemand';

export const backToOffer = (): ThunkAction<void, IState, IContext> => {
  return (dispatch, getState) => {
    const {
      requestDemand: { selectedUserType },
    } = getState();
    const isHomeOwner = selectedUserType === EUserType.HOME_OWNER;

    dispatch(closeDemandRequestModal());

    trackBackToOffer(isHomeOwner);
  };
};
